import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { WaitlistForm } from "@/components/WaitlistForm";
import { SuccessPanel } from "@/components/SuccessPanel";
import { WAITLIST } from "@/constants/testIds/waitlist";

const STEPS = [
  ["01", "Join the waitlist", "Leave your name and email, plus your WhatsApp number if you like."],
  ["02", "Hear first", "We contact you when enrolment opens."],
];

export default function Landing() {
  const [joined, setJoined] = useState(null);

  return (
    <div className="grain min-h-screen bg-background text-foreground" data-testid={WAITLIST.page}>
      <div className="grid lg:grid-cols-2 min-h-screen">
        <main className="flex flex-col justify-between px-6 py-8 sm:px-12 lg:px-20 xl:px-24 lg:py-12">
          <header className="flex items-center justify-between">
            <span className="font-display text-2xl tracking-tight">Archana <span className="italic text-primary">Relationship</span> School</span>
            <span className="hidden sm:inline text-xs tracking-[0.2em] uppercase text-muted-foreground border border-border rounded-full px-3 py-1">Online · Opening soon</span>
          </header>

          <section className="py-14 lg:py-20">
            <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }}
              className="text-sm tracking-[0.2em] uppercase text-accent mb-6">Waitlist now open</motion.p>
            <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }}
              className="font-display text-5xl sm:text-6xl xl:text-7xl leading-[0.95] tracking-tight mb-6" data-testid={WAITLIST.headline}>
              Interested in the course?<br /><span className="italic text-primary">Save your seat.</span>
            </motion.h1>
            <motion.p initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }}
              className="text-base md:text-lg text-muted-foreground max-w-md leading-relaxed mb-10">
              Archana Relationship School is opening its online classes soon. Join the waitlist and be the first to know when enrolment opens.
            </motion.p>
            {joined ? <SuccessPanel name={joined} /> : <WaitlistForm onSuccess={setJoined} />}
          </section>

          <footer className="flex items-center justify-between text-xs text-muted-foreground">
            <span>© {new Date().getFullYear()} Archana Relationship School</span>
            <Link to="/admin" className="hover:text-primary transition-colors" data-testid={WAITLIST.adminLink}>Admin</Link>
          </footer>
        </main>

        <aside className="relative hidden lg:flex items-center overflow-hidden bg-secondary border-l border-border">
          <span aria-hidden="true" className="font-display italic absolute -top-24 -right-10 text-[34rem] leading-none text-primary/10 select-none">A</span>
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.6 }}
            className="relative m-10 xl:m-14 max-w-md bg-white/75 backdrop-blur-xl border border-white/60 rounded-lg p-7">
            <p className="text-xs tracking-[0.2em] uppercase text-muted-foreground mb-5">What happens next</p>
            <ol className="space-y-4">
              {STEPS.map(([n, t, d]) => (
                <li key={n} className="flex gap-4">
                  <span className="font-display text-2xl text-primary leading-none">{n}</span>
                  <div><p className="font-medium">{t}</p><p className="text-sm text-muted-foreground">{d}</p></div>
                </li>
              ))}
            </ol>
          </motion.div>
        </aside>
      </div>

      <section className="lg:hidden px-6 sm:px-12 pb-16">
        <p className="text-xs tracking-[0.2em] uppercase text-muted-foreground mb-5">What happens next</p>
        <ol className="space-y-4">
          {STEPS.map(([n, t, d]) => (
            <li key={n} className="flex gap-4">
              <span className="font-display text-2xl text-primary leading-none">{n}</span>
              <div><p className="font-medium">{t}</p><p className="text-sm text-muted-foreground">{d}</p></div>
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
}
